import { TinyColor, mostReadable } from '@ctrl/tinycolor';
import { clickDarken, clickLighten, focusLighten, focusDarken, hoverLighten, hoverDarken } from './style.js';
import { colors } from '../../constants/colors.js';
import { defaultTheme } from '../theming/Theme.js';

var defaultColor = colors.forestGreen;
var defaultDisabledColor = colors.cloudGrey;
var generateTextLuminances = function generateTextLuminances(kind, theme) {
  return function (_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? defaultColor : _ref$color,
        _ref$disabledColor = _ref.disabledColor,
        disabledColor = _ref$disabledColor === void 0 ? defaultDisabledColor : _ref$disabledColor,
        textColorProp = _ref.textColorProp;
    // istanbul ignore next
    theme = theme || defaultTheme;
    var textColors = [theme.colors.text, theme.colors.background];
    var base = new TinyColor(kind === 'disabled' ? disabledColor : color);
    var luminance = base.getLuminance();
    return {
      get bg() {
        switch (kind) {
          case 'normal':
          case 'disabled':
            return base.toHexString();

          case 'hover':
            if (luminance < 0.1) {
              return base.lighten(hoverLighten).toHexString();
            } else {
              return base.darken(hoverDarken).toHexString();
            }

          case 'focus':
            if (luminance < 0.1) {
              return base.lighten(focusLighten).toHexString();
            } else {
              return base.darken(focusDarken).toHexString();
            }

          case 'click':
            if (luminance > 0.9) {
              return base.darken(clickDarken).toHexString();
            } else {
              return base.lighten(clickLighten).toHexString();
            }

        }
      },

      get fg() {
        var _mostReadable;

        if (kind === 'disabled') return luminance < 0.1 ? colors.emperorGrey : colors.fogGrey; // This previously had darken(20), I guess the reason was to have white text on optimisticGreen background
        // Removed the darkening as on dark theme we want to actually use the better contrast case
        // istanbul ignore next

        var text = textColorProp || ((_mostReadable = mostReadable(base, textColors)) === null || _mostReadable === void 0 ? void 0 : _mostReadable.toHexString()) || new TinyColor(textColors[0]).toHexString();
        return text;
      }

    };
  };
};

export { generateTextLuminances };
